import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../../Service/app-service';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginForm: any;
  isPasswordVisible: boolean = false;

  constructor(private fb: FormBuilder,private SpinnerService: NgxSpinnerService, private tosterService: ToastrService, private authService: AuthService, private router: Router) { }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      username: [localStorage.getItem('rememberUsername') || '', Validators.required],
      password: [localStorage.getItem('rememberPassword') || '', Validators.required],
      rememberMe: [!!localStorage.getItem('rememberUsername')]
    });
  }

  onSubmit() {
    if (this.loginForm.valid) {
      this.SpinnerService.show();
      const { username, password, rememberMe } = this.loginForm.value;
      this.authService.login(username, password).subscribe(
        (response) => {
          localStorage.setItem('username', JSON.stringify(response.data['email']));
          localStorage.setItem('role', JSON.stringify(response.data['roles']));
          if (response.status == true) {
            localStorage.setItem('token', JSON.stringify(response.data['accessToken']));
            this.tosterService.success('Login Successfully');
            this.router.navigate(['/dashboard']);
          } else {
            this.tosterService.error(response.message);
          }
          if (rememberMe) {
            localStorage.setItem('rememberUsername', username);
            localStorage.setItem('rememberPassword', password);
          } else {
            localStorage.removeItem('rememberUsername');
            localStorage.removeItem('rememberPassword');
          }
          this.SpinnerService.hide();
        },
        (error) => {
          this.tosterService.error(error.message);
          console.error('Login failed', error);
          this.SpinnerService.hide();
        }
      );
    } else {
      this.loginForm.markAllAsTouched();
    }
  }
}
